export interface MapValue {
    address?: string
    displayName?: string // old mobile data
    geometry?: {
        location?: {
            lat: number
            lng: number
        }
    }
}

export const DEFAULT_MAP_CENTER = { lat: 37.0902, lng: -95.7315 }

/**
 * Check if a MapValue has valid, finite lat/lng coordinates
 */
export function hasValidCoords(value: MapValue | null | undefined): boolean {
    const loc = value?.geometry?.location
    return !!loc && isFinite(loc.lat) && isFinite(loc.lng)
}

/**
 * Normalize any saved map value into a usable MapValue or null.
 * Handles: null, undefined, legacy string format, and object format.
 */
export function normalizeMapValue(value: unknown): MapValue | null {
    if (value == null) return null

    // legacy string format from old mobile app
    if (typeof value === 'string') {
        return value.trim()
            ? { address: value.trim() }
            : null
    }

    // already an object
    if (typeof value === 'object') {
        return value as MapValue
    }

    return null
}
